import React from 'react';
import './MeetAlicia.css';

const MeetAlicia = () => {
  return (
    <div className="meet-alicia">
      <div className="meet-alicia-container">
        <div className="meet-alicia-content">
          <div className="meet-alicia-text">
            <h1>Meet Alicia</h1>
            <p>
                Hello and welcome! I am a Licensed Professional Counselor based in sunny Austin, Texas.
                With a deep sense of empathy and warmth, I offer a safe, non-judgmental space for individuals
                to explore their emotions, work through challenges, and begin their healing journey.
            </p>
            <p>
                I specialize in working with grief, trauma, and attachment wounds—areas where I've found that 
                true healing often requires a gentle, integrative approach. My training in “Integrative Yoga Therapy” 
                allows me to blend mindfulness, breathwork, and body-centered practices with traditional therapeutic 
                techniques, helping clients reconnect with themselves on both an emotional and physical level.
            </p>
            <p>
                I feel incredibly fortunate to work from my backyard office surrounded by the beauty of magnolia trees. 
                In my personal life, I’m someone who enjoys the quieter, more reflective moments of life. I love reading, 
                exploring new ideas and philosophies, cooking, going to art museums, 
                walking with friends and family, and spending time at local parks and trails.
            </p>
            <p>
                If you're looking for a therapist who is empathetic, patient, and deeply committed to your healing, I would 
                love to support you in navigating your journey. Whether you're working through emotional pain, seeking personal 
                growth, or dealing with life transitions, I'm here to walk alongside you every step of the way.
            </p>
            <p>
                Feel free to reach out—I’d be honored to connect with you.
            </p>
            <div className="credentials">
              <h3>Credentials & Training</h3>
              <ul>
                <li>Licensed Professional Counselor (State of Texas)</li>
                <li>Master's Degree in Mental HealthCounseling</li>
                <li>Specialized training in trauma-informed care</li>
                <li>Experience with diverse populations and presenting concerns</li>
              </ul>
            </div>
          </div>
          <div className="meet-alicia-image">
            <img src="/images/IMG_9603_A.jpg" alt="Alicia Gostylo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetAlicia;
